/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerReprocessOlafReprocessMutationRequest, TriggerReprocessOlafReprocessMutationResponse } from "../models/TriggerReprocessOlafReprocess";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { triggerReprocessOlafReprocess } from "../axios/triggerReprocessOlafReprocess";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const triggerReprocessOlafReprocessMutationKey = () => ["audit-reports-api", { url: '/olaf/reprocess' }] as const

export type TriggerReprocessOlafReprocessMutationKey = ReturnType<typeof triggerReprocessOlafReprocessMutationKey>

export function triggerReprocessOlafReprocessMutationOptions<TContext = unknown>(config: Partial<RequestConfig<TriggerReprocessOlafReprocessMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = triggerReprocessOlafReprocessMutationKey()
        return mutationOptions<TriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<Error>, {data: TriggerReprocessOlafReprocessMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return triggerReprocessOlafReprocess(data, config)
          },
        })

}

/**
 * @summary Trigger standalone OLAF reprocess
 * {@link /olaf/reprocess}
 */
export function useTriggerReprocessOlafReprocess<TContext>(options: 
{
  mutation?: UseMutationOptions<TriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<Error>, {data: TriggerReprocessOlafReprocessMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<TriggerReprocessOlafReprocessMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? triggerReprocessOlafReprocessMutationKey()

          const baseOptions = triggerReprocessOlafReprocessMutationOptions(config) as UseMutationOptions<TriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<Error>, {data: TriggerReprocessOlafReprocessMutationRequest}, TContext>
          

          return useMutation<TriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<Error>, {data: TriggerReprocessOlafReprocessMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<Error>, {data: TriggerReprocessOlafReprocessMutationRequest}, TContext>
      
}